import { cn } from '@/lib/utils'

interface JuneaLogoSmallProps {
  className?: string
}

export function JuneaLogoSmall({ className }: JuneaLogoSmallProps): React.ReactElement {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 35 48"
      className={cn('h-auto text-white', className)}
    >
      <path
        d="M30.0946 29.3699C29.2036 29.3699 25.8826 29.7859 23.9845 30.3775C28.0183 22.9006 34.2444 11.9824 34.2444 5.45639C34.2471 1.54238 32.052 0 28.8499 0C20.191 0 3.22699 11.2153 3.22699 19.9374C3.22699 21.9552 4.88748 24.9805 6.19157 24.9805C6.84497 24.9805 7.37687 24.2674 7.55507 22.4873C7.67386 21.3609 7.73326 19.9941 8.26786 18.5706C10.8166 11.4503 24.1033 4.15172 26.9491 4.15172C27.7213 4.15172 28.1938 4.5677 28.1938 5.57524C28.1938 10.7966 19.5349 28.1814 17.5774 31.2662C14.2591 32.398 0.5 37.8544 0.5 41.8305C0.5 45.0935 2.99209 48 6.90437 48C12.7768 48 19.9534 38.2109 21.1387 35.6583C22.621 33.1057 29.4412 31.6822 31.6956 31.3256C31.8738 30.969 31.9926 30.6719 31.9926 30.3775C31.9926 29.5482 31.1017 29.3699 30.0946 29.3699ZM14.3185 37.5005C12.7174 39.5183 10.6412 41.5955 8.80246 42.7219C6.19157 44.3831 3.93978 44.7991 3.52399 43.9077C2.98939 42.7219 7.08257 40.1098 8.98066 39.0429C10.3442 38.3892 12.064 37.6194 13.4275 37.2628C14.0215 37.0845 14.6155 37.0251 14.3185 37.5005Z"
        fill="currentColor"
      />
    </svg>
  )
}
